<template>
  <section class="categories-section">
    <categories-logos :logos="rawLogos" :active-index="index" @index="updateIndex"></categories-logos>
    <categories-contents :contents="rawContents" :active-index="index"></categories-contents>
  </section>
</template>

<script>
    export default {
        name: "CategoriesViewer",
        data() {
            return {
                index: 0
            }
        },
        computed: {
            rawContents() {
                const contents = this.$slots.default;
                if (contents) {
                    return contents.filter(x => typeof x.tag !== 'undefined');
                }
                return null;
            },
            rawLogos() {
                const { logos } = this.$slots;
                if (logos) {
                    return logos.filter(x => x.tag === 'img');
                }
                return null;
            }
        },
        methods: {
            updateIndex(index) {
                this.index = index;
            }
        }
    }
</script>
